/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceFilterByPolicyResponse {
    getFixupPrototypeFunction() { return ComplianceFilterByPolicyResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceFilterByPolicyResponse>): ComplianceFilterByPolicyResponse {
        let obj = Object.assign(new ComplianceFilterByPolicyResponse(), model);
        ComplianceFilterByPolicyResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceFilterByPolicyResponse>): ComplianceFilterByPolicyResponse {
        if (!model) return null;
        return ComplianceFilterByPolicyResponse.newInstance(<ComplianceFilterByPolicyResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceFilterByPolicyResponse) {
        if (!obj) return;

        models.ComplianceFilterByPolicyResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceFilterByPolicyResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceFilterByPolicyResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            models.ComplianceStandard.fixupPrototype(this.tenants);
        }
    }

    /**
     * Return all of the Resource type given the tenant as input
     */
    resource_type: Array<any>;

    /**
     * Tenants data for compliance posture filters
     */
    tenants: models.ComplianceStandard;

    /**
     * Policies for compliance posture filters
     */
    policies: Array<any>;

    /**
     * Compliance standards for compliance posture filters
     */
    compliance_standards: Array<any>;

    /**
     * severity for compliance posture filters
     */
    severity: Array<any>;

}
